(function () {
'use strict';

angular.module('hyresgastApp').controller('AgreementsListCtrl', AgreementsListCtrl);

function AgreementsListCtrl($location,
  Agreement) {
  var vm = this;

  vm.tableColumns = [
    {
      title: 'ID',
      column: 'id',
    },
    {
      title: 'Text',
      column: 'name',
    },
    {
      title: 'Antal fastigheter',
      column: 'numProperties',
    },
    {
      title: 'Antal lägenheter',
      column: 'numApartments',
    },
    {
      title: 'Ansvarig hos HGF',
      column: 'hgfNegotiator.fullName',
    },
    {
      title: 'Ansvarig hos organisation',
      column: 'extNegotiator.fullName',
    },
    {
      title: 'Signerad',
      column: 'signed',
      type: 'boolean',
    },
    {
      title: 'Skapad den',
      column: 'createdAt',
      type: 'date',
    },
  ];

  vm.tableFGetData = Agreement.find;

  vm.gotoAgreement = agreement => {
    $location.search({});
    $location.path('/negotiations/' + agreement.negotiationId + '/agreements/' + agreement.id);
  };

  vm.getContextInfo = row => ({
    title: `Överenskommelse ${row.id}`,
    link: '/negotiations/' + row.negotiationId + '/agreements/' + row.id,
  });
}
})();